import { motion } from 'framer-motion';

// Route-level entrance: content lifts in behind a gold hairline sweep.
export const PageTransition = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 18 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -10 }}
    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    className="relative"
  >
    <motion.span
      aria-hidden="true"
      className="fixed top-[72px] left-0 right-0 h-[0.5px] bg-gold origin-left z-[70]"
      initial={{ scaleX: 0, opacity: 1 }}
      animate={{ scaleX: 1, opacity: 0 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
    />
    {children}
  </motion.div>
);

export default PageTransition;
